import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RegisterEmailRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RegisterEmailResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const registerEmail = (request: RegisterEmailRequest, options?: CashRequestOptions) =>
  post<RegisterEmailRequest, RegisterEmailResponse>('/2.0/cash/register-email', request, {
    ...options,
    rejectOnError: true,
  })
